import { Injectable } from '@angular/core';

import { PermissionConfigItemEntity } from '../../../../ui/components/app-permissions-configurator/permission-config-item.entity';
import {
	PermissionConfig,
	PermissionConfigListEntity,
} from '../../../../ui/components/app-permissions-configurator/permission-config-list.entity';

@Injectable()
export class PermissionListProvider {
	private permissionConfigList!: PermissionConfigListEntity;

	public constructor() {}

	public setList(
		columns: Array<PermissionConfig>,
		elements: Array<PermissionConfigItemEntity>
	): PermissionConfigListEntity {
		this.permissionConfigList = PermissionConfigListEntity.build(columns);

		const elems = new Map(elements.map((item) => [`${item.id}`, item]));
		return this.permissionConfigList.setElements(elems);
	}

	public setElements(
		elements: Array<PermissionConfigItemEntity>
	): PermissionConfigListEntity {
		const elems = new Map(elements.map((item) => [`${item.id}`, item]));
		return this.permissionConfigList.setElements(elems);
	}
}
